import type { ParsedBusiness } from "~/data/.server/business";

export function AdditionalInformationSection(props: {
  business: ParsedBusiness;
}) {
  const { carrierInfo } = props.business;
  const { detail, docketNumbers, oos } = carrierInfo ?? {};

  // Extract relevant data from carrierInfo.detail
  const { ein, censusTypeId, carrierOperation, snapshotDate } = detail ?? {};

  // Docket Numbers

  // Out-of-Service Summary
  const oosDate = oos?.oosDate;
  const oosReason = oos?.oosReason;
  const oosReasonDescription = oos?.oosReasonDescription;

  return (
    <div className="grid-row-flow grid grid-cols-2">
      {/* Employer Identification Number (EIN) */}
      <div>
        <div className="mb-6">
          <p>
            <span className="font-semibold">
              Employer Identification Number (EIN):
            </span>{" "}
            {ein || "N/A"}
          </p>
        </div>

        {/* Census Type */}
        <div className="mb-6">
          <h3 className="mb-2 font-semibold">Census Type</h3>
          <p>
            <span className="font-semibold">Census Type:</span>{" "}
            {censusTypeId?.censusType || "N/A"}
          </p>
          <p>
            <span className="font-semibold">Description:</span>{" "}
            {censusTypeId?.censusTypeDesc || "N/A"}
          </p>
        </div>

        {/* Carrier Operation */}
        <div className="mb-6">
          <h3 className="mb-2 font-semibold">Carrier Operation</h3>
          <p>
            <span className="font-semibold">Operation Code:</span>{" "}
            {carrierOperation?.carrierOperationCode || "N/A"}
          </p>
          <p>
            <span className="font-semibold">Operation Description:</span>{" "}
            {carrierOperation?.carrierOperationDesc || "N/A"}
          </p>
        </div>
      </div>
      <div>
        {/* Snapshot Date */}
        <div className="mb-6">
          <p>
            <span className="font-semibold">Snapshot Date:</span>{" "}
            {snapshotDate || "N/A"}
          </p>
        </div>

        {/* Docket Numbers */}
        <div className="mb-6">
          <h3 className="mb-2 font-semibold">Docket Numbers</h3>
          {(docketNumbers?.length ?? 0 > 0) ? (
            <table className="min-w-full border">
              <thead>
                <tr>
                  <th className="border px-4 py-2">Docket Number</th>
                  <th className="border px-4 py-2">Prefix</th>
                </tr>
              </thead>
              <tbody>
                {docketNumbers?.map((docket, index) => (
                  <tr key={index}>
                    <td className="border px-4 py-2">
                      {docket?.docketNumber || "N/A"}
                    </td>
                    <td className="border px-4 py-2">
                      {docket?.prefix || "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No docket numbers available.</p>
          )}
        </div>

        {/* Out-of-Service Summary */}
        <div className="mb-6">
          <h3 className="mb-2 font-semibold">Out-of-Service Summary</h3>
          <p>
            <span className="font-semibold">Out-of-Service Date:</span>{" "}
            {oosDate || "N/A"}
          </p>
          <p>
            <span className="font-semibold">Out-of-Service Reason:</span>{" "}
            {oosReason || "N/A"}
          </p>
          <p>
            <span className="font-semibold">Reason Description:</span>{" "}
            {oosReasonDescription || "N/A"}
          </p>
        </div>
      </div>
    </div>
  );
}
